// removed by extract-text-webpack-plugin
module.exports = {"BuildControl":"BuildControl__BuildControl__ibcUQ","Label":"BuildControl__Label__2VLnR","Less":"BuildControl__Less__3X6hg","More":"BuildControl__More__2eQpV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BuildControls/BuildControl/BuildControl.css
// module id = 132
// module chunks = 3